type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export default function TrashIcon({ className, ...props }: Props) {
  return (
    <svg
      {...props}
      className={className}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8815 1.37186C10.8815 1.20693 10.816 1.04876 10.6994 0.932138C10.5828 0.815517 10.4246 0.75 10.2597 0.75H5.74085C5.57592 0.75 5.41775 0.815517 5.30113 0.932138C5.1845 1.04876 5.11899 1.20693 5.11899 1.37186V2.98869H0.641602V4.23241H1.74022V14.3894C1.74022 15.1481 2.0416 15.8757 2.57806 16.4122C3.11451 16.9486 3.84211 17.25 4.60077 17.25H11.4412C11.8159 17.25 12.1869 17.1759 12.5328 17.0319C12.8787 16.8879 13.1927 16.6768 13.4566 16.4109C13.7206 16.145 13.9294 15.8295 14.0709 15.4826C14.2123 15.1356 14.2838 14.7641 14.281 14.3894V4.23241H15.3589V2.98869H10.8815V1.37186ZM5.7823 13.4152H4.53859V6.36746H5.7823V13.4152ZM8.62213 13.4152H7.37841V6.36746H8.62213V13.4152ZM9.63783 2.98869H6.36271V1.99372H9.63783V2.98869ZM11.462 6.36746V13.4152H10.2182V6.36746H11.462Z"
        fill="currentcolor"
      />
    </svg>
  );
}
